// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"c160fe71","252":"3328c978","320":"3e4d4ffa","608":"b66b1033","787":"1e5faf0e"}[chunkId] + ".chunk.js";
};